//production credentials : uncomment when building a prod build
const apiPath = 'https://api.kokos.ai/';    
const apiKey = 'MoFm3cF6uo1lcb1P8ZThu6FVoDwP7YGP9EZw5bjH';

//dev credentials : 
// const apiPath = 'https://dev-api.kokos.ai/';
// const apiKey = 'KMOvYuwzEJ4Y249d1z3HTNhKa8eLlsBaLLcHVDBj';




export {
    apiPath,
    apiKey
}